<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>

  <form [formGroup]="inputForm">

    <!-- Name -->
    <mat-form-field>
      <mat-label>{{ 'Name' | translate }}</mat-label>
      <input matInput formControlName="name" required>
      <mat-error>
        Name is required
      </mat-error>
    </mat-form-field>

    <!-- Description -->
    <mat-form-field>
      <mat-label>{{ 'Description' | translate }}</mat-label>
      <textarea matInput formControlName="description" rows="10"></textarea>
    </mat-form-field>

  </form>

</div>
<div mat-dialog-actions class="actions">
  <button mat-button (click)="dialogRef.close()">{{ 'Cancel' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="inputForm.invalid" [mat-dialog-close]="result" cdkFocusInitial>{{ data.confirmBtnLabel | translate }}</button>
</div>
